const theme = {
  token: {
    fontFamily: "'Quicksand', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif",
    colorPrimary: "#356AB3",
    colorLink: "#356AB3",
    colorBorderSecondary: "#D8DFE6"
  },
  components: {
    Layout: {
      bodyBg: "#FFFFFF",
      siderBg: "#234B8C",
      headerBg: "transparent"
    },
    Menu: {
      darkItemBg: "transparent",
      iconSize: 24,
      iconMarginInlineEnd: 15,
      darkItemSelectedBg: "transparent",
      itemHeight: 50,
      itemBorderRadius: 0,
      darkItemColor: "#5373A5",
      darkItemSelectedColor: "#E4ECF2",
      itemMarginInline: 0,
      itemMarginBlock: 0
    },
    Button: {
      primaryShadow: "none",
    },
  },
};

export default theme;
